import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    Alert
  } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card } from "components/Card/Card.jsx";
import { SSSEntriesCard } from "components/EntriesCards/SSSEntriesCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchSssRequest, editSssRequest, createSssGroupRequest } from "../../../api/sss";

class SSSForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        salaryFrom: '',
        salaryTo: '',
        employerShare: '',
        employeeShare: '',
        totalContribution: '',
        effectiveDate: '',
        entries: []
      },
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchSssRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result,
                  entries: [
                    {
                      ...prevState.resource,
                      ...result
                    }
                  ]
              },
          })), error => this.setState({ error: 'There was an error' }));
  }

  onChangeDate = (date, field) => {
    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [field]: date
      }
    }));
  };

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      effectiveDate,
      entries=[]
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    if (isNewRecord) {

      let data = {
        entries: entries.map(entry => ({ ...entry, effectiveDate })),
        effectiveDate
      };

      createSssGroupRequest(data,
        result => this.saveSuccess(),
        error => this.saveFailure(error)
      );
    } else {

      let data = {
        ...this.state.resource.entries[0],
        effectiveDate
      }

      editSssRequest(instanceId, data,
        result => this.saveSuccess(),
        error => this.saveFailure(error)
      );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.handleGoToList()
  }

  handleGoToList = () => {
    const { effectiveDate } = this.state.resource
    this.props.goToList('sss', `${moment(effectiveDate).format('YYYY/MM/DD')}`, 'date');
  }

  saveFailure = (error) => {
      console.log(error)
      this.setState({ error: error.message || 'There was an error saving SSS.' })
  }

  addEntry = () => {
    const updatedEntries = [...this.state.resource.entries];
    updatedEntries.push({
      salaryFrom: '',
      salaryTo: '',
      employerShare: '',
      employeeShare: '',
      totalContribution: '',
      isPercentage: false,
      percentageValue: 0
    });
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }));
  }

  deleteEntry = (index) => {
    const { entries } = this.state.resource;
    const updatedEntries = [...entries];
    updatedEntries.splice(index, 1);
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }))
  }

  onUpdateEntry = (entry, index) => {
    const { entries } = this.state.resource;
    let updatedEntries = [...entries];
		updatedEntries[index] = {
			...updatedEntries[index],
			...entry
		}
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }));
  }

  render() {

    const {
      effectiveDate,
      entries
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const {
      error
    } = this.state;

    const isNewRecord = !instanceId;

    if (isNewRecord) {
      return (
        <Row>
          <Alert bsStyle="info">
            To create a new group, add all salary tiers that apply and their information
            <br />
            * All tiers will have the same effective date and will work as a group
            <br />
            * The values can be edited later but not the effective date
            <br />
            * For percentages, add the percentage number without any symbol: (eg: if the percentage is 2.75%, type 2.75)
          </Alert>
          <Col md={12}>
            <Card
              title="New Group"
              content={
                <form>
                  <Button className="card-top-btn btn-primary" onClick={() => this.props.goBack()}>
                    Back to List
                  </Button>
                  <FormGroup>
                    <ControlLabel>Group Effective Date</ControlLabel>
                    <DatePicker
                      selected={effectiveDate ? moment(effectiveDate, 'YYYY/MM/DD').toDate() : ''}
                      onChange={(date) => this.onChangeDate(date,'effectiveDate')}
                      dateFormat="MM/dd/yyyy"
                      className="dateInput"
                      dropdownMode="select"
                      showYearDropdown
                      timeFormat={false}
                    />
                  </FormGroup>
                  <Card 
                    hideFooter 
                    content={
                      <div>
                        <div className="add-rule-container">
                          <p className="category">Entries <span className="required-star">*</span></p>
                          <Button className="pull-right" bsStyle="primary" bsSize="sm" onClick={this.addEntry}>Add Entry</Button>
                        </div>
                        {
                          entries.map((entry, index) => {
                            return (
                              <SSSEntriesCard key={index} onUpdateEntry={this.onUpdateEntry} index={index} deleteEntry={this.deleteEntry} entry={entry} />  
                            )
                          })
                        }
                      </div>
                    }
                  />
                  {error &&
                    <Alert bsStyle="danger">
                      {error}
                    </Alert>
                  }         
                  <Button bsStyle="primary" pullRight fill onClick={this.save}>
                    {isNewRecord ? "Create" : "Save changes"}
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col md={12}>
            <Card
              title="Edit Entry"
              content={
                <form>
                  <Button className="card-top-btn btn-primary" onClick={() => this.props.goBack()}>
                    Back to List
                  </Button>
                  <div className="clearfix" />
                  <SSSEntriesCard onUpdateEntry={this.onUpdateEntry} index={0} deleteEntry={this.deleteEntry} entry={entries[0]} />  
                  <Button bsStyle="primary" pullRight fill onClick={this.save}>
                    Save changes
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      )
    }
  }
}

export default SSSForm;
